"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalWindow = exports.ModalSizes = exports.ModalHeader = exports.ModalFooter = exports.ModalContent = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var utilities_1 = require("../../utilities");
var __1 = require("../");
var hooks_1 = require("../../hooks");
var ModalContent = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.scrollable, scrollable = _b === void 0 ? true : _b;
    var ModalContentClassNames = classnames_1.default('Modal__content', className, {
        'Modal__content--scrollable': scrollable,
    });
    return react_1.default.createElement("div", { className: ModalContentClassNames }, children);
};
exports.ModalContent = ModalContent;
exports.ModalContent.displayName = 'ModalContent';
var ModalFooter = function (_a) {
    var _b = _a.align, align = _b === void 0 ? 'right' : _b, children = _a.children, className = _a.className, props = __rest(_a, ["align", "children", "className"]);
    var ModalFooterClassNames = classnames_1.default('Modal__footer', className, {
        'Modal__footer--left': align === 'left',
        'Modal__footer--center': align === 'center',
        'Modal__footer--right': align === 'right',
        'Modal__footer--space-between': align === 'space-between',
    });
    return (react_1.default.createElement("div", __assign({ className: ModalFooterClassNames }, props), children));
};
exports.ModalFooter = ModalFooter;
exports.ModalFooter.displayName = 'ModalFooter';
var ModalHeader = function (_a) {
    var className = _a.className, closable = _a.closable, title = _a.title, onClose = _a.onClose, props = __rest(_a, ["className", "closable", "title", "onClose"]);
    if (!closable && title == null) {
        return null;
    }
    var Close = function () { return (react_1.default.createElement(__1.Button, { fill: "subtle", className: "Modal__header-close", iconName: "clear", size: "xsmall", onClick: onClose })); };
    var ModalHeaderClassNames = classnames_1.default('Modal__header', className);
    return (react_1.default.createElement("div", __assign({ className: ModalHeaderClassNames }, props),
        react_1.default.createElement(__1.Headline, { className: "Modal__header-title" }, title),
        closable && react_1.default.createElement(Close, null)));
};
exports.ModalHeader = ModalHeader;
exports.ModalHeader.displayName = 'ModalHeader';
/**
 * Modal Sizes
 */
var ModalSizes;
(function (ModalSizes) {
    ModalSizes["XS"] = "XS";
    ModalSizes["S"] = "S";
    ModalSizes["M"] = "M";
    ModalSizes["L"] = "L";
})(ModalSizes = exports.ModalSizes || (exports.ModalSizes = {}));
function sizeClass(size) {
    return "Modal--" + size;
}
var ModalWindow = function (_a) {
    var children = _a.children, className = _a.className, closable = _a.closable, onClose = _a.onClose, _b = _a.size, size = _b === void 0 ? ModalSizes.M : _b, focusScopeOptions = _a.focusScopeOptions, props = __rest(_a, ["children", "className", "closable", "onClose", "size", "focusScopeOptions"]);
    var ModalWindowClassNames = classnames_1.default('Modal', sizeClass(size), className);
    var overlayContext = react_1.useContext(utilities_1.OverlayContext);
    var backdropRef = react_1.useRef(null);
    var handleTab = hooks_1.useFocusScope(backdropRef, focusScopeOptions).handleTab;
    return (react_1.default.createElement(__1.Backdrop, __assign({ className: ModalWindowClassNames, closeOnClick: !!(closable || onClose), onClick: onClose, ref: backdropRef, onKeyDown: handleTab }, props),
        react_1.default.createElement(utilities_1.OverlayContext.Provider, { value: overlayContext.concat('modal') }, children)));
};
exports.ModalWindow = ModalWindow;
//# sourceMappingURL=components.js.map